export default __webpack_public_path__ + "static/media/alIcon0627.b40aa327.png";